'use strict';

var core = require('core/product/quickView');
var focusHelper = require('base/components/focus');
var modal = require('../components/modal');
const { updateAddAllToCart } = require('./detail');

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    var $modal = $('#quickViewModal');
    $modal.find('.modal-body').spinner().start();
    $modal.find('.modal-body, .modal-footer').hide();

    return new Promise((resolve, reject) => {
        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            dataType: 'json',
            success: function(data) {
                var parsedHtml = modal.parseHtml(data.renderedTemplate);
                $modal.find('.modal-body').empty().html(parsedHtml.body);
                var assetPromises = [];
                var hasVideo = false;
                // Process assets
                if ('pdpGalleryAssets' in data.product) {
                    var pdpGalleryAssets = data.product.pdpGalleryAssets;
                    var $assetSlides = $modal.find('.primary-images-main .pdp-gallery-asset');

                    if ($assetSlides && $assetSlides.length > 0) {
                        $assetSlides.each((index, slide) => {
                            var $slideElement = $(slide);
                            var asset = pdpGalleryAssets[index];
                            if (asset && asset.isVideo) {
                                hasVideo = true;
                            }

                            if (asset && asset.assetRenderUrl) {
                                let assetPromise = $.ajax({
                                    url: asset.assetRenderUrl,
                                    method: 'GET'
                                }).done(assetData => {
                                    $slideElement.html(assetData);
                                }).fail(err => {
                                    console.error('Error retrieving asset:', err);
                                });

                                assetPromises.push(assetPromise);
                            }
                        });
                    }
                }

                // Wait for all asset Ajax calls to complete before resolving
                $.when.apply($, assetPromises).then(() => {
                    $('body').trigger('quickview:ready', $('#quickViewModal'));
                    $modal.find('.modal-footer').html(parsedHtml.footer);
                    $modal.find('.full-pdp-link').text(data.quickViewFullDetailMsg);
                    $modal.find('.full-pdp-link').attr('data-href', data.productUrl);
                    $modal.find('.modal-header .close .sr-only').text(data.closeButtonText);
                    $modal.find('.enter-message').text(data.enterDialogMessage);
                    $modal.find('#quickViewModal').modal('show');

                    if (data.dialogTitle) {
                        $modal.find('.modal-header').prepend('<div class="modal-title">' + data.dialogTitle + '</div>');
                    }

                    if (data.product.productType === 'set') {
                        updateAddAllToCart();
                    }

                    // Customization QUICK VIEW for 'Build Your Own Bundle' Page
                    if ($('.page-boyb').length) {
                        $modal.find($('.swatch.row')).remove();
                        $modal.find('[data-transactional-element]').remove();
                        var productPrice = data.product.price.sales.formatted;
                        var productId = data.product.id;
                        var addToBundleBtn = `<button class="quick-view_add js-quickview-add-to-bundle" data-dismiss="modal" data-action="productAdd" data-productid="${productId}">Add to bundle*(${productPrice})</button>`;
                        $modal.find('.modal-footer > .col').remove();
                        $modal.find('.modal-footer').append(addToBundleBtn);
                    }

                    $('body').trigger('modal:loaded', $('#quickViewModal'));
                    $('body').trigger('tooltip:init');
                    $('body').trigger('quantitySteppers:Enable');
                    $modal.find('.modal-body, .modal-footer').show();

                    if (hasVideo) {
                        $('body').trigger('ajax:load.ajaxEvents', [$modal.find('.slider-container')]);
                        $('body').trigger('slider:videosLoaded');
                    }

                    $.spinner().stop();
                    resolve(); // Resolve the promise when everything is complete
                });
            },
            error: function() {
                $.spinner().stop();
                reject('Error loading quick view modal.');
            }
        });
    });
}

core.showQuickview = function() {
    $('body').on('click', '.quickview', function (e) {
        e.preventDefault();
        var selectedValueUrl = $(this).attr('data-href');
        modal.getModalHtmlElement('quickViewModal', 'quick-view-dialog');
        fillModalElement(selectedValueUrl)
            .then(() => {
                $(e.target).trigger('quickview:show');
            })
            .catch(error => {
                console.error("Quick view failed:", error);
            });
    });
}

module.exports = core;
